import breadcrumbs from './breadcrumbs.json';
import buttons from './buttons.json';
import labels from './labels.json';
import messages from './messages.json';
import multiselect from './multiselect.json';
import texts from './texts.json';
import application from './application.json';

export default {
  breadcrumbs, buttons, labels, messages, multiselect, texts, application
}
